import React, { forwardRef } from "react"
import { Icon as MUIIcon, IconProps } from "@mui/material"
import { useStyles } from "./styles"
import { CustomIconsType } from "./types"
import getCustomIconComponent from "./customIcons"

interface Props extends IconProps {
  name: CustomIconsType
}

const CustomIcon: React.FC<Props> = forwardRef(({ name, ...props }, ref) => {
  const { classes, cx } = useStyles()

  const Icon = getCustomIconComponent(name)

  return (
    !!Icon && (
      <MUIIcon
        ref={ref}
        {...props}
        className={cx(props.className, classes.customIcon)}
      >
        <Icon />
      </MUIIcon>
    )
  )
})

export default CustomIcon
